// Copyright 2022, Imprivata, Inc.  All rights reserved.
import { Flex, Image } from 'antd';
import { HexagonSpinner } from '@imprivata-cloud/patient-access-ui-components';
import './Photo.less';
export interface PhotoProps {
  image?: string;
}
const Photo = (props: PhotoProps) => {
  return (
    <Flex align="center" vertical className="photo-flex-container">
      {props.image ? <Image width="100%" src={`${props.image}`} /> : <HexagonSpinner data-testid="loading-spinner" />}
    </Flex>
  );
};
export default Photo;
